import * as i0 from "@angular/core";
export class HeaderBarStore {
}
HeaderBarStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HeaderBarStore_Factory() { return new HeaderBarStore(); }, token: HeaderBarStore, providedIn: "root" });
export var HeaderBarStoreKeys;
(function (HeaderBarStoreKeys) {
})(HeaderBarStoreKeys || (HeaderBarStoreKeys = {}));
